import { SxProps } from '@mui/system';
import { colorTokens } from '@rideiq/shared/components/variables';

export const StyledFormGroupSx: SxProps = {
  display: 'flex',
  flexDirection: 'row',
  '.MuiFormControlLabel-label': { fontWeight: '200', color: colorTokens.text.dark },
};
